module.exports = __webpack_public_path__ + "53c11bb1faef55c59deb6e88292792b4.svg";